import createSagaMiddleware from '@redux-saga/core'
import { configureStore } from '@reduxjs/toolkit'
import { rootSaga } from './root-saga'

//types
import type { InitialStateLogin } from '../features/authentication/presentation/redux/reducers/login-reducer'
import type { RefreshJwtState } from '../features/authentication/presentation/redux/reducers/refresh-jwt-reducer'
import type { InitialStateJourney } from '../features/journey/presentation/redux/reducers/journey-reducer'
import { type InitialCreateCollectionOrder } from '../features/collectionorder/presentation/redux/reducers/create-collection-order-reducer'
import type { initialStateGetUser } from '../features/user/presentation/redux/reducers/get-user-reducer'
import type { ResetPasswordReducerState } from '../features/user/presentation/redux/reducers/reset-password-reducer'
import dailySalesReducer from '../store/daily-sales/daily-sales.slice'
import type { DailySalesState } from '../store/daily-sales/daily-sales.slice'

//reducers
import { AuthReducer } from '../features/authentication/presentation/redux/reducers/combine-reducers'
import { JourneyReducer } from '../features/journey/presentation/redux/reducers/combine-reducers'
// Novo slice para listagem paginada de previous closings
import JourneyListReducer from '../store/journey/journey.slice'
import type { JourneyListState } from '../store/journey/journey.slice'
import { CollectionOrderReducer } from '../features/collectionorder/presentation/redux/reducers/combine-reducers'
import type { InitialGetCollectionOrderStatus } from '../features/collectionorder/presentation/redux/reducers/get-collection-order-status-reducer'
import { UserReducer } from '../features/user/presentation/redux/reducers/combine-reducers'
import type { CollectionOrderState } from '../store/daily-sale/collection-order.slice'
import { userOnboardingReducer } from '../store/user-onboarding'
import type { UserOnboardingState } from '../store/user-onboarding/user-onboarding.slice'
import collectionOrderReducer from '../store/daily-sale/collection-order.slice'

export type StateDefault = {
  success: boolean
  load: boolean
  error: string
}

export type InitialAuth = {
  login: typeof InitialStateLogin
  refreshJwt: RefreshJwtState
}

export type InitialJourney = {
  journey: typeof InitialStateJourney
}

export type InitialUser = {
  getUser: typeof initialStateGetUser
  resetPassword: ResetPasswordReducerState
  changePassword: StateDefault
}

export type InitialCollectionOrderState = {
  createCollectionOrder: typeof InitialCreateCollectionOrder
  getCollectionOrderStatus: typeof InitialGetCollectionOrderStatus
}

export type RootState = {
  auth: InitialAuth
  user: InitialUser
  journey: InitialJourney
  collectionOrder: CollectionOrderState
  userOnboarding: UserOnboardingState
  journeyList: JourneyListState
  createCollectionOrder: InitialCollectionOrderState
  dailySales: DailySalesState
}

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(sagaMiddleware),
  reducer: {
    auth: AuthReducer,
    user: UserReducer,
    journey: JourneyReducer,
    collectionOrder: collectionOrderReducer,
    userOnboarding: userOnboardingReducer,
    journeyList: JourneyListReducer,
    createCollectionOrder: CollectionOrderReducer,
    dailySales: dailySalesReducer,
  },
})

// Tipos auxiliares comuns em apps Redux
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
// Caso deseje usar a inferência automática do estado completo:
// export type RootState = ReturnType<typeof store.getState>

sagaMiddleware.run(rootSaga)
